export type PublicGlanceUnit = {
  id: string;
  path: string;
  canonicalUrl: string;
  socialImageUrl: string;
  title: string;
  sentence: string;
  selectedWord: string;
  partOfSpeech: string;
  pronunciation: string;
  meaningHere: string;
  simplerMeaning: string;
  languageWork: string;
  readingId: string;
  readingTitle: string;
  readingHref: string;
  studyId: string;
  studyTitle: string;
  studyHref: string;
  provenance: string;
};

export type MomentOfNeedPath = {
  id: string;
  label: string;
  promise: string;
  studyId: string;
  studyTitle: string;
  readingId: string;
  readingTitle: string;
};

export const PUBLIC_GLANCE_UNITS: readonly PublicGlanceUnit[] = [
  {
    id: "insinuation-at-midnight",
    path: "/glance/insinuation-at-midnight.html",
    canonicalUrl: "https://verbalore.com/glance/insinuation-at-midnight.html",
    socialImageUrl: "https://verbalore.com/glance/insinuation-at-midnight.png",
    title: "insinuation, in context",
    sentence: "“That,” he whispered, “is an outrageous insinuation.”",
    selectedWord: "insinuation",
    partOfSpeech: "noun",
    pronunciation: "/ɪnˌsɪnjuˈeɪʃən/",
    meaningHere: "An unpleasant accusation or suggestion made indirectly.",
    simplerMeaning: "He means: you accused me without saying the accusation openly.",
    languageWork: "He tries to move the argument away from whether the accusation is true and towards whether it was polite. The narrator refuses that escape.",
    readingId: "visitor-at-midnight",
    readingTitle: "The Visitor at Midnight",
    readingHref: "/?view=read&work=visitor-at-midnight&time=brief&mood=tense",
    studyId: "disagree-without-a-fight",
    studyTitle: "Disagree without a fight",
    studyHref: "/?view=practice&practice=expression&study=disagree-without-a-fight&stance=tactful",
    provenance: "Original Verbalore reading, edition 2026-07-16.1",
  },
];

export const MOMENT_OF_NEED_PATHS: readonly MomentOfNeedPath[] = [
  {
    id: "disagree-without-a-fight",
    label: "Disagree without starting a fight",
    promise: "Register the disagreement clearly while keeping the working relationship intact.",
    studyId: "disagree-without-a-fight",
    studyTitle: "Disagree without a fight",
    readingId: "any-other-business",
    readingTitle: "Any Other Business",
  },
  {
    id: "say-no-without-shrinking",
    label: "Say no without becoming smaller",
    promise: "Make the refusal final without apologising for having a boundary.",
    studyId: "a-no-that-stays-no",
    studyTitle: "A no that stays no",
    readingId: "the-cost-of-being-clear",
    readingTitle: "The Cost of Being Clear",
  },
  {
    id: "correct-without-humiliating",
    label: "Correct without humiliating",
    promise: "Name the error and get it fixed while leaving the other person’s standing intact.",
    studyId: "correct-dont-crush",
    studyTitle: "Correct, don’t crush",
    readingId: "the-reconciliation",
    readingTitle: "The Reconciliation",
  },
  {
    id: "say-something-difficult",
    label: "Say something difficult tomorrow",
    promise: "Tell the hard truth without softening it into something untrue.",
    studyId: "the-truth-whole",
    studyTitle: "The truth, whole",
    readingId: "the-last-key",
    readingTitle: "The Last Key",
  },
  {
    id: "make-the-point-carry",
    label: "Make a point carry more weight",
    promise: "Compress the point until its force comes from precision rather than volume.",
    studyId: "cut-to-the-point",
    studyTitle: "Cut to the point",
    readingId: "visitor-at-midnight",
    readingTitle: "The Visitor at Midnight",
  },
];
